import { Menu } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/layout/Sidebar'
import { LanguageSwitcher } from '@/components/layout/LanguageSwitcher'
import { EventTicker } from '@/components/layout/EventTicker'
import { useOnline } from '@/hooks/useOnline'

export function AppShell() {
  const { t } = useTranslation()
  const [mobileMenu, setMobileMenu] = useState(false)
  const online = useOnline()

  return (
    <div className="flex h-dvh min-h-0 bg-[color:var(--stryzh-color-void)]">
      <Sidebar
        mobileOpen={mobileMenu}
        onCloseMobile={() => setMobileMenu(false)}
      />
      <div className="flex h-dvh min-h-0 max-h-dvh min-w-0 flex-1 flex-col overflow-hidden lg:pl-0">
        {!online ? (
          <div className="shrink-0 border-b border-[color:var(--stryzh-color-semantic-error)] bg-[color:var(--stryzh-color-order-card-timeout-bg)] px-4 py-2 text-center font-[family-name:var(--stryzh-font-family-inter)] text-[length:var(--stryzh-font-size-sm)] text-[color:var(--stryzh-color-semantic-error)]">
            {t('common.offline')}
          </div>
        ) : null}
        <header className="relative flex h-[var(--stryzh-layout-header-height)] shrink-0 items-center border-b border-[color:var(--stryzh-color-border-default)] bg-[color:var(--stryzh-color-void)] px-4 lg:hidden">
          <button
            type="button"
            className="relative z-10 -ml-1 rounded-[var(--stryzh-radius-sm)] p-1.5 text-[color:var(--stryzh-color-text-primary)] hover:bg-[color:var(--stryzh-color-border-subtle)]"
            aria-label={t('nav.menu')}
            onClick={() => setMobileMenu(true)}
          >
            <Menu size={28} strokeWidth={2} aria-hidden />
          </button>
          <span className="pointer-events-none absolute left-1/2 top-1/2 z-0 -translate-x-1/2 -translate-y-1/2">
            <img src="/carlink.png" alt="Carlink" className="h-[22px] w-auto" />
          </span>
          <LanguageSwitcher className="relative z-10 ml-auto" />
        </header>
        <main className="flex min-h-0 flex-1 flex-col overflow-y-auto bg-[color:var(--stryzh-color-void)] p-4">
          <Outlet />
        </main>
        <EventTicker />
      </div>
    </div>
  )
}
